/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 更换手机号时获取验证码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  phoneCaptchaRequest: member.PhoneCaptchaRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/setting/phone/captcha`,
    data: phoneCaptchaRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
